import React from "react";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";

export const FeaturesSection: React.FC = () => {
	const { t } = useTranslation();
	const featureItems: { subTitle: string; paragraph: string }[] = t("featuresSection.items", {
		returnObjects: true,
	});

	return (
		<section className={styles.FeaturesSection__wrapper}>
			<div className={"app-container"}>
				<div className={styles.FeaturesSection__contentWrapper}>
					<h1 className={styles.FeaturesSection__title}>{t("featuresSection.title")}</h1>

					{Array.isArray(featureItems) &&
						featureItems.map((item, index) => (
							<React.Fragment key={index}>
								<h3 className={styles.FeaturesSection__subTitle}>{item.subTitle}</h3>
								<p className={styles.FeaturesSection__paragraph}>{item.paragraph}</p>
							</React.Fragment>
						))}
				</div>
			</div>
		</section>
	);
};
